import { PickedAnswerRequest } from '../../../models/requests/pickedAnswer.request';
import axios from '../../../utilities/axios';

export const pickedAnswerRequest = async (request: PickedAnswerRequest): Promise<void> => {
  try {
    const response = await axios.post<void>(
      `${process.env.REACT_APP_BASE_URL}/answers/picked`,
      {...request}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
